export const VALUES = [
  {
    id: 'customers-first',
    title: 'Customers First',
    description:
      'People put their trust in us at some of the toughest moments in their lives. Because it’s so important, their needs are front and centre in everything we do. ',
    illustration: 'illustrations/Customers_First',
  },
  {
    id: 'make-it-simple',
    title: 'Make it simple',
    description:
      'Death is overwhelming and complicated. So we put time and effort into communicating clearly. We believe in the power of simplicity - it’s rocket fuel for progress. ',
    illustration: 'illustrations/Make_It_Simple',
  },
  {
    id: 'move-with-urgency-and-focus',
    title: 'Move with urgency and focus',
    description:
      'Focus is gold dust. 80% of execution issues come from the lack of it - so we keep the goal in sight. And when the time for action comes, we go for it with maximum energy, passion and drive. ',
    illustration: 'illustrations/Move_With_Urgency_Focus',
  },
  {
    id: 'sweat-the-details',
    title: 'Sweat the details',
    description:
      'We make the effort to really know our stuff and do the little things well. We value the expertise in each of our roles and are committed to producing surprisingly great work.',
    illustration: 'illustrations/Sweat_The_Details',
  },
  {
    id: 'act-intrapreneurial',
    title: 'Act intrapreneurial',
    description:
      'We’re all owners here - custodians of our customers, brand, products and culture. We expect everyone to take ownership and drive positive change. When we see a way to improve, we make it happen.',
    illustration: 'illustrations/Act_Intrapreneurial',
  },
  {
    id: 'be-kind-have-fun-celebrate-the-wins',
    title: 'Be kind, have fun, celebrate the wins',
    description:
      'Life is short, and mostly about who you spend it with. We work hard, and though it’s sometimes stressful and challenging, you’ll find yourself alongside other enthusiastic, kind, dedicated people here. ',
    illustration: 'illustrations/Be_kind_Have_fun',
  },
] as const
